module.exports = __webpack_public_path__ + "static/media/decros@3x.884a22ec.png";